<template>
  <div class="mb-2 border rounded p-2">
    <h5 class="pl-2 mb-0">
      <small class="text-muted">
        <font-awesome-icon icon="grip-lines" />
      </small>
      {{ client.name }}
    </h5>
  </div>
</template>

<script>

export default {
  name: 'DraggableList',
  props: {
    client: {
      type: Object,
      required: true
    },
    products: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      name: ''
    }
  }
}
</script>

<style scoped>

</style>
